export default __webpack_public_path__ + "static/artifakt-element-black-2b1df495d8dd5bb41cb087b361bebb76.woff";